import type { ScoreFeedEntry } from "../simulation/snapshot";

const KIND_CLASS: Record<ScoreFeedEntry["kind"], string> = {
  kill: "feed-kill",
  chain: "feed-chain",
  double_kill: "feed-multi",
  triple_kill: "feed-multi",
  overkill: "feed-style",
  tactician: "feed-style",
  salvage: "feed-salvage",
  time: "feed-time",
};

/** Last-five score event ticker (top-right). */
export class ScoreFeed {
  private lastKey = "";

  public constructor(private readonly root: HTMLElement) {}

  public sync(entries: readonly ScoreFeedEntry[]): void {
    const key = entries.map((e) => `${e.id}:${e.label}`).join("|");
    if (key === this.lastKey) return;
    this.lastKey = key;

    if (entries.length === 0) {
      this.root.hidden = true;
      return;
    }

    this.root.hidden = false;
    this.root.innerHTML = entries
      .slice()
      .reverse()
      .map(
        (entry) => `
        <div class="feed-row ${KIND_CLASS[entry.kind]}">
          <span class="feed-label">${entry.label}</span>
          <span class="feed-points">+${entry.points.toLocaleString()}</span>
        </div>`,
      )
      .join("");
  }
}
